<script setup>
import { ref, computed } from 'vue';
import { useQuery } from 'villus';
import FeaturedGrid from '@/components/featured-grid/FeaturedGrid.vue';
import { useStore } from '@/store/Store.js';

const posts = ref([]);

const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
    color: {
        type: String,
        default: '',
    },
    themeColor: {
        type: String,
        default: '',
    },
    center: {
        type: Boolean,
        default: false,
    },
});

const store = useStore();
const variables = computed(() => ({
    lang: store.lang.value,
    relations: props?.data?.data?.categoryOrTag ? props?.data?.data?.categoryOrTag.map((item) => item.id) : null,
}));

if (props.data.data.categoryOrTag) {
    const { data: queryData } = await useQuery({
        variables,
        query: `
            query FetchFeaturedPostsRelatedTo ($lang: [String], $relations: [QueryArgument]) {
                entries(relatedTo: $relations, site: $lang, limit: 6) {
                    id,
                    title,
                    uri,
                    ... on blog_Entry {
                        day: postDate @formatDateTime (format: "d"),
                        month: postDate @formatDateTime (format: "n"),
                        year: postDate @formatDateTime (format: "Y"),
                        category: blogCategory { title },
                        cover: blogCover { title, url @transform (format: "webp", quality: 80, width: 800, height: 426, immediately: true) },
                    }
                    ... on recette_Entry {
                        category: recetteCategory { title },
                        cover: recetteCover { title, url @transform (format: "webp", quality: 80, width: 800, height: 426, immediately: true) },
                    }
                }
            }
        `,
    });

    posts.value = queryData.value.entries;
}
</script>
<template>
    <FeaturedGrid
        v-if="posts && posts.length > 0"
        :posts="posts"
        :title-top="data.data.featuredContentTitle"
        :cta-link="data.data.link[0].url"
        :cta="data.data.link[0].text"
        :bg="color"
        :color="color"
        :cta-color="themeColor"
    />
</template>
